var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWhiteCaret(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.6487 3.1893L4.85686 6.77002C5.49052 7.3092 6.51413 7.3092 7.14779 6.77002L11.356 3.1893C12.3796 2.31831 11.6484 0.825195 10.2024 0.825195H1.78604C0.339993 0.825195 -0.374907 2.31831 0.6487 3.1893Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhiteCaret);
export default __webpack_public_path__ + "static/media/iconWhiteCaret.4b12d9b25211f8822f5a710a99cc71e5.svg";
export { ForwardRef as ReactComponent };